import { error } from "pdf-lib";
import * as Yup from "yup";
import { postMarketPriceSearchTableInfoListAPI } from "../../../http/api/MarketPriceAPI";
import { Destination } from "@aws-sdk/client-ses";

// export const validationSchema = Yup.object().shape({
//   customerCd: Yup.string().required("Customer is required"),
//   shopName: Yup.string().required("Shop name is required"),
// });

const fieldTranslations = {
  marketPriceName: "市況価格表名", // 必須
  isUsingSellingPrice: "売価", // If this true then primePriceMarkUpRate and sellingPriceMarkUpRate is require
  primePriceMarkUpRate: "原価値入率",  // 0 => 100, integer
  sellingPriceMarkUpRate: "売価値入率", // 0 => 100, integer
  deliveryPriceAdditionCd: "納品価格",  // 必須 >0
  deliveryPriceAdditionAmount: "納品価格加算量",  // long
  unitPriceCd: "単価",  // 必須 >0
  orderFormColumnCountDirectionCd: "注文票列数向き",  // 必須 >0 
  orderFormProductTypePartitionCd: "注文表種別分割",  // 必須 >0
  orderFormDeadlineHourOutputCd: "注文票締め切り時間出力",  // 必須 >0
  orderFormOrderQuantityOutputCd: "注文票注文数量出力",  // 必須 >0
  orderDeadlineHour: "注文締め切り時間",  // 0 => 23 ,integer
  orderFormContactCd: "注文票連絡先",  // 必須 >0
  shippingDateInitialSettingCd: "出荷日初期設定",  // 必須 >0
  orderFormShopSummaryCd: "注文票店舗集約",  // 必須 >0
  destinationOutputCd: "あて名出力", // 必須
  usingShops: "使用店舗",  // length > 0 必須 it is a list of {customerId,shopId} both of them require value >0 and is number.
  businessPartnersAndStores: "取引先と店舗"  // 必須
};

const usingShopsSchema = Yup.array()
  .of(
    Yup.object().shape({
      customerId: Yup.number()
        .typeError('取引先を選択してください。') // 値が数値であることを確認
        .positive('取引先を選択してください。') // 値が正の数であることを確認
        .required('取引先を選択してください。') // 値が必須であることを確認
        .nullable(false) // 値がnullでないことを確認
        .test('not-empty', '取引先を選択してください。', value => value !== ''), // 値が空文字列でないことを確認
      shopId: Yup.number()
        .typeError('店舗を選択してください。') // 値が数値であることを確認
        .positive('店舗を選択してください。') // 値が正の数であることを確認
        .required('店舗を選択してください。') // 値が必須であることを確認
        .nullable(false) // 値がnullでないことを確認
        .test('not-empty', '店舗を選択してください。', value => value !== ''), // 値が空文字列でないことを確認
    })
  );
  
export function marketPriceCustomCheck(formData) {
  const shops = formData.usingShops;
  const seen = new Map();
  const errors = {};

  shops.forEach((shop, index) => {
    const key = `${shop.customerId}-${shop.shopId}`;
    if (seen.has(key)) {
      const message = '同じ取引先と店舗の組み合わせがありますので、変更するか、削除してください。';
      const firstIndex = seen.get(key);


      if (!errors[`usingShops[${firstIndex}].shopId`] && !errors[`usingShops[${index}].shopId`]) {
        errors[`usingShops[${firstIndex}].shopId`] = message;
        errors[`usingShops[${index}].shopId`] = message;
      }
    } else {
      seen.set(key, index);
    }
  });

  return errors;
}

export const marketPriceSchema = Yup.object().shape({
  marketPriceName: Yup.string().required('市況価格表名を入力してください。'),

  isUsingSellingPrice: Yup.boolean(),

  primePriceMarkUpRate: Yup.mixed()
    .transform((value, originalValue) => originalValue === '' ? 0 : value)
    .nullable()
    .typeError('原価値入率は数値です。')
    .when('isUsingSellingPrice', ([isUsingSellingPrice]) => {
      if (isUsingSellingPrice) {
        return Yup.number()
          .required('原価値入率を入力してください。')
          .typeError('原価値入率は数値です。')
          .min(0, '原価値入率は0以上です。')
          .max(100, '原価値入率は100以下です。')
      } else {
        return Yup.mixed().nullable(true);
      }
    }),

  sellingPriceMarkUpRate: Yup.mixed()
    .transform((value, originalValue) => originalValue === '' ? 0 : value)
    .nullable()
    .typeError('売価値入率は数値です。')
    .when('isUsingSellingPrice', ([isUsingSellingPrice]) => {
      if (isUsingSellingPrice) {
        return Yup.number()
          .required('売価値入率を入力してください。')
          .typeError('売価値入率は数値です。')
          .min(0, '売価値入率は0以上です。')
          .lessThan(100, '売価値入率は100未満です。')
      } else {
        return Yup.mixed().nullable(true);
      }
    }),


  deliveryPriceAdditionAmount: Yup.mixed()
    .transform((value, originalValue) => originalValue === '' ? null : value)
    .nullable()
    .typeError('納品価格加算量は数値です。')
    .when('deliveryPriceAdditionCd', ([deliveryPriceAdditionCd]) => {
      if (deliveryPriceAdditionCd > 1) {
        return Yup.number()
          .required('納品価格加算量を選択してください。')
          .typeError('納品価格加算量は数値です。');
      } else {
        return Yup.mixed().nullable(true);
      }
    }),

  unitPriceCd: Yup.number()
    .positive('単価を選択してください。')
    .required('単価は必須です。'),

  orderFormColumnCountDirectionCd: Yup.number()
    .positive('注文票列数向きを選択してください。')
    .required('注文票列数向きは必須です。'),

  orderFormProductTypePartitionCd: Yup.number()
    .positive('注文表種別分割を選択してください。')
    .required('注文表種別分割は必須です。'),

  orderFormDeadlineHourOutputCd: Yup.number()
    .positive('注文票締め切り時間出力を選択してください。')
    .required('注文票締め切り時間出力は必須です。'),

  orderFormOrderQuantityOutputCd: Yup.number()
    .positive('注文票注文数量出力を選択してください。')
    .required('注文票注文数量出力は必須です。'),

  orderDeadlineHour: Yup.number()
    .typeError('注文締め切り時間は整数です。')
    .integer('注文締め切り時間は整数です。')
    .min(0, '注文締め切り時間は0以上です。')
    .max(23, '注文締め切り時間は23以下です。'),

  orderFormContactCd: Yup.number()
    .positive('注文票連絡先を選択してください。')
    .required('注文票連絡先は必須です。'),

  shippingDateInitialSettingCd: Yup.number()
    .positive('出荷日初期設定を選択してください。')
    .required('出荷日初期設定は必須です。'),

  orderFormShopSummaryCd: Yup.number()
    .positive('注文票店舗集約を選択してください。')
    .required('注文票店舗集約は必須です。'),
  
  destinationOutputCd: Yup.number()
    .positive('あて名出力を選択してください。')
    .required('あて名出力は必須です。'),

  usingShops: usingShopsSchema,

});

const MarketPriceCacheSync = (function () {
  let marketPriceNames = null;
  let isFetching = false;

  return {
    fetch(refetch = false) {
      if (marketPriceNames == null || refetch) {
        if (!isFetching) {
          isFetching = true;
          postMarketPriceSearchTableInfoListAPI({}).then((res) => {
            marketPriceNames = res.marketPriceTableInfoList.map(item => item.marketPriceName);
            isFetching = false;
          }).catch(() => {
            isFetching = false;
          });
        }
      }
      return marketPriceNames;
    },

    exists(marketPriceName, refetch = false) {
      const names = this.fetch(refetch);
      if (names) {
        return names.includes(marketPriceName);
      }
      return false;
    }
  };
})();

export const validMarketPriceNameSync = (marketPriceName, refetch = false) => {
  const marketPriceNameExisted = MarketPriceCacheSync.exists(marketPriceName, refetch);
  return marketPriceNameExisted;
};
